import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferComponent } from './offer.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrokenImageHomeDirective } from '../../directives/broken-image-home';
import { FlashmessageModule } from '../flashmessage/flashmessage.module';

const routes: Routes = [
  {
      path: '',
      component: OfferComponent
  }
]


@NgModule({
  declarations: [OfferComponent, BrokenImageHomeDirective],
  imports: [
    CommonModule,
    FormsModule,
    FlashmessageModule,
    RouterModule.forChild(routes)
  ],
  exports: [OfferComponent]
})
export class OfferModule { }
